import { Fragment } from "react";
import Notification from "../../Notification";
import HexLoader from "../../HexLoader";

const HexMapFooter = ({
  editable,
  mapNotification,
  loading,
  modal,
  onClose,
  handleSave,
}) => {
  if (!editable) return null;

  return (
    <Fragment>
      <div className="hex-map-footer p-1">
        {mapNotification && (
          <Notification message={mapNotification} type="danger" />
        )}

        {loading ? (
          <HexLoader />
        ) : (
          modal && (
            <div className="hex-map-actions">
              <button
                type="button"
                className="hex-map-btn hex-map-btn-ghost"
                onClick={onClose}
              >
                Cancel
              </button>
              <button
                type="button"
                className="hex-map-btn hex-map-btn-primary"
                onClick={handleSave}
                disabled={Boolean(mapNotification)}
              >
                Use this location
              </button>
            </div>
          )
        )}
      </div>
    </Fragment>
  );
};

export default HexMapFooter;
